import { addCommas, createUserCountryCache, getArgentinaDiscountValue, getCurrenciesValues, setCookieWithSelector, setUserCurrencyByIp } from "./commons/commonPricing";
import { readCookie, setCookie } from "./commons/cookies";
import { triggerChange } from "./commons/eventTarget";
import { getUserCountryByIp } from "./commons/userIp";
import { getCurrentVersion } from "./commons/version";
import { loadSmsScript } from "./sms";

const getObjPricing = async () => {
	const url = '/backend/pricing/prices.json?version=' + getCurrentVersion();
	const resp = await fetch(url);
	const data = await resp.json();
	return data;
}

const createOption = (key, currencyData) => {
	const newOption = document.createElement("option");
	newOption.value = key;
	newOption.dataset.rate = currencyData.rateValue;
	newOption.dataset.currency = currencyData.currencySymbol;
	newOption.textContent = `${currencyData.currencySymbol} ${decodeURIComponent(escape(currencyData.currencyName))}`;
	return newOption;
}


const loadSelectorOptions = (currencies) => {
	for (const key in currencies) {
		if (Object.hasOwnProperty.call(currencies, key)) {
			const currencyData = currencies[key];
			const newOption = createOption(key, currencyData);
			currencySelector.appendChild(newOption);
		}
	}
}

const replaceEuroSymbol = () => {
	document.querySelectorAll(".currency > option").forEach(elem => {
		elem.innerHTML = elem.innerHTML.replace("euro", "€");
	});

}

const setValueWithCookie = () => {
	const currencySelectorCookie = readCookie('currencySelector');
	const currentCurrencyCookie = readCookie('currentCurrency');
	if (currencySelectorCookie != null) {
		currencySelector.value = currencySelectorCookie;
		setTimeout(() => { triggerChange(currencySelector); }, time);
	} else if (currentCurrencyCookie != null) {
		const currentCookie = JSON.parse(currentCurrencyCookie);
		const currentCookieValue = currentCookie.value;
		setTimeout(() => { currencySelector.value = currentCookieValue; }, time);
	} else {
		setUserCurrencyByIp();
	}
}

const tabPricingListener = () => {
	// Funcion para manejar el clic en los tabs de precios
	const tabsPricing = document.querySelectorAll('.sub-navigation-pricing ul li');
	if (tabsPricing)
		tabsPricing.forEach(tab => {
			tab.addEventListener('click', (event) => {
				if (!sessionStorage.getItem('pricing')) {
					sessionStorage.setItem('pricing', true);
				}
				event.currentTarget.querySelector('a').click();
			});
		})
}



const getUserCountryCached = createUserCountryCache();

const showFixedNoticeForArgentina = () => {
	const notice = document.querySelector('.fixed-notice');
	/* El chequeo de notice en el if se puede sacar si se resuelve donde se llama el script de precios*/
	if (notice && countryCode === 'AR') {
    notice.classList.add('fixed-notice--display');
		const closeNotice = document.querySelector('.fixed-notice__close');
		closeNotice.addEventListener('click', function () {
			notice.style.display = "none";
		})
	}
}

const updateDisplayedPrices = (price, calcBox, currencyInfo) => {
	calcBox.querySelectorAll('.dp-prices .amount').forEach(item => {
		item.innerHTML = addCommas(price);
		item.setAttribute('data-unit-price', price);
	});
	calcBox.querySelectorAll('.dp-prices .money').forEach(item => {
		item.innerHTML = currencyInfo.symbol;
		if (currencyInfo.symbol === 'euro') item.innerHTML = '€';
	});
}

const updateEmailCost = (mailCost, calcBox, currencyInfo) => {
	const unitCostMessage = calcBox.querySelector('.unit-cost-message .value');
	const convertedMailCost = (parseFloat(mailCost) * parseFloat(currencyInfo.rate)).toFixed(5);
	unitCostMessage.innerHTML = `${currencyInfo.symbol} ${convertedMailCost}`;
}

const handleSpecialDiscount = (item, quantity, activeButtonDiscount, calcBox, currencyInfo) => {
	const quantityValue = parseInt(quantity);
	const isValidQuantity = (quantityValue <= 10000 || quantityValue === 500) && (currencySelector.value == 'ARS' || currencySelector.value == 'USD') && activeButtonDiscount === '0';
	const isPanelDiscount = countryCode === 'AR' && loadSpecialDiscount && isValidQuantity;
	const panelDiscount = calcBox.querySelector('.dp-wrap-subscription .btn-active').parentElement;
	const discQty = isPanelDiscount ? specialDiscountValueForArgentina : parseInt(panelDiscount.getAttribute('data-value'));

	if (discQty > 0) {
		const price = (item.value * currencyInfo.rate).toFixed(2);
		const valuePerTime = price * panelDiscount.getAttribute('data-time');
		const discountValue = ((valuePerTime * discQty) / 100).toFixed(2);
		const discountPerMonth = ((valuePerTime - discountValue) / parseInt(panelDiscount.getAttribute('data-time'))).toFixed(2);

		calcBox.querySelectorAll('.dp-price-old').forEach(item => { item.display = 'block'; });
		if (isValidQuantity) {
			calcBox.querySelectorAll('.dp-price-old').forEach(dpPriceSpan => { dpPriceSpan.classList.add('special-discount-old-price') })
		} else {
			calcBox.querySelectorAll('.dp-price-old').forEach(dpPriceSpan => { dpPriceSpan.classList.remove('special-discount-old-price') })
		}

		calcBox.querySelectorAll('.dp-price-old .dp-price-old-amount').forEach(item => { item.innerHTML = addCommas(price); });
		calcBox.querySelectorAll('.dp-prices .amount').forEach(item => { item.innerHTML = addCommas(discountPerMonth); });
		calcBox.querySelector('.disccount-message .disccount-value').innerHTML = `${currencyInfo.symbol} ${addCommas((valuePerTime - discountValue).toFixed(2))}`;

		if (calcBox.querySelector('.disccount-message .disccount-value').innerHTML.includes("euro")) {
			calcBox.querySelector('.disccount-message .disccount-value').innerHTML = `€ ${addCommas((valuePerTime - discountValue).toFixed(2))}`;
		}
	} else {
		calcBox.querySelectorAll('.dp-price-old').forEach(item => { item.display = 'none'; });
	}
}

const updateProgressBar = (planObj) => {
	const planName = planObj.planName;
	document.querySelectorAll('.progress-bar').forEach(item => {
		const inputPlanName = item.querySelector('input').id;
		if (!inputPlanName.includes(planName)) return;
		const inputBar = item.querySelector('.range-slider');
		const max = inputBar.getAttribute('max');
		const inputBarProgress = (100 * inputBar.value) / max;
		const dataValue = inputBar.getAttribute('data-value');
		inputBar.parentElement.querySelector('.progress-anchor').style.width = inputBarProgress + '%';
		inputBar.closest('.dp-bgplan').querySelector('.dp-calc-quantity span').innerHTML = addCommas(dataValue);
	});
}

const showHideSpecialDiscount = (calcBox, activeButtonDiscount) => {
	let quantityValue = document.querySelector('.dp-calc-quantity span').innerHTML;
	if ((countryCode === 'AR') && ((quantityValue <= 10.000) || quantityValue === '500') && (currencySelector.value == 'ARS' || currencySelector.value == 'USD') && activeButtonDiscount === '0' && specialDiscountValueForArgentina > 0) {
		calcBox.querySelectorAll('.dp-price-old').forEach(item => { item.style.display = 'block'; });
		calcBox.querySelectorAll('.special-discount-message').forEach(item => { item.style.display = 'block'; });
		document.querySelector('.argetina-discount').classList.add('show');
	} else if (activeButtonDiscount === '0') {
		calcBox.querySelectorAll('.dp-price-old').forEach(item => { item.style.display = 'none'; });
		calcBox.querySelectorAll('.special-discount-message').forEach(item => { item.style.display = 'none'; });
		document.querySelector('.argetina-discount').classList.remove('show');
	}
}

const calculatePrices = (type, quantity, element, objPricing) => {
	const currency = readCookie('currentCurrency');
	if (!currency) return;

	const calcBox = element.closest('.dp-calc-box');
	const activeButtonDiscount = document.querySelector('.btn-active').parentNode.getAttribute('data-value');
	const isDiscountPanel = !!calcBox.querySelector('.dp-wrap-subscription');
	const currencyInfo = JSON.parse(currency);

	objPricing.forEach((item) => {

		if (type.includes(item.planName) && item.range === quantity) {

			let price = (item.value * currencyInfo.rate).toFixed(2);
			updateDisplayedPrices(price, calcBox, currencyInfo);

			if (!!item.mailCost) {
				updateEmailCost(item.mailCost, calcBox, currencyInfo);
			}

			if (isDiscountPanel) {
				handleSpecialDiscount(item, quantity, activeButtonDiscount, calcBox, currencyInfo);
			}

			updateProgressBar(item);

			if (isDiscountPanel) {
				showHideSpecialDiscount(calcBox, activeButtonDiscount);
			}

		}
	});
}

const messageSuggestion = (arrayPrices, bgPlan, value) => {
	// Esta funcion se encarga de mostrar el mensaje
	// para cada tipo de plan cuando llega al maximo
	let arrayLength = arrayPrices.length - 1;

	if (arrayLength == value) {
		bgPlan.querySelector('.dp-calc-message').classList.add('show');
	} else {
		bgPlan.querySelector('.dp-calc-message').classList.remove('show');
	}
}

const loadRanges = (objPricing) => {

	// Carga el rango de precio para cada tipo de plan disponible y sus valores
	const rangeForContacts = document.getElementById('range-plus-contactos');
	const rangeForEmails = document.getElementById('range-plus-envios');
	const rangeForCredits = document.getElementById('range-plus-creditos');
	const contactValues = [];
	const emailValues = [];
	const creditsValues = [];
	objPricing.forEach(function (entry) {
		switch (entry.planName) {
			case 'plus-contactos':
				contactValues.push(entry.range);
				break;
			case 'plus-envios':
				emailValues.push(entry.range);
				break;
			case 'plus-creditos':
				creditsValues.push(entry.range);
				break;
		}
	});

	const initializeRange = (rangeElement, valuesArray) => {
		if (rangeElement != null) {
			rangeElement.setAttribute('data-value', valuesArray[rangeElement.value]);
			rangeElement.setAttribute('value', rangeElement.value);
			messageSuggestion(
				valuesArray,
				rangeElement.closest('.dp-bgplan'),
				rangeElement.value,
			);
			calculatePrices(
				rangeElement.id,
				valuesArray[rangeElement.value],
				rangeElement,
				objPricing
			);
		}
	};

	const handleRangeInputChange = (rangeElement, valuesArray) => {
		if (rangeElement != null) {
			rangeElement.addEventListener('input', () => {
				rangeElement.setAttribute('data-value', valuesArray[rangeElement.value]);
				rangeElement.setAttribute('value', rangeElement.value);
				messageSuggestion(
					valuesArray,
					rangeElement.closest('.dp-bgplan'),
					rangeElement.value,
				);
				calculatePrices(rangeElement.id, valuesArray[rangeElement.value], rangeElement, objPricing);
			});
		}
	};

	handleRangeInputChange(rangeForContacts, contactValues);
	handleRangeInputChange(rangeForEmails, emailValues);
	handleRangeInputChange(rangeForCredits, creditsValues);


	initializeRange(rangeForContacts, contactValues);
	initializeRange(rangeForEmails, emailValues);
	initializeRange(rangeForCredits, creditsValues);

}

const getCurruntActiveCalcQuantity = () => {
	const activeCalcQuantityAmount = document.querySelector('.tab--content.active .dp-calc-quantity span').innerText;
	return Number(activeCalcQuantityAmount);
}

const isQuantityEligibleForSpecialDiscount = () => {
  const quantity = getCurruntActiveCalcQuantity();
  return quantity <= 10.000 || quantity === 500;
}

const loadDiscount = async (elem) => {
	const objCCurrency = JSON.parse(readCookie('currentCurrency'));
	const calcBox = elem.closest('.dp-calc-box');
	const elemDataValue = elem.getAttribute('data-value');
	const isValidCurrencyForSpecialDiscount = (objCCurrency.value === 'ARS' || objCCurrency.value === 'USD')
	const initialValue = calcBox.querySelector('.dp-prices .amount').getAttribute('data-unit-price');

	const valuePerTime = (initialValue * elem.getAttribute('data-time'));
  //const discount = ((countryCode === 'AR') && loadSpecialDiscount && isValidCurrencyForSpecialDiscount && elemDataValue === '0' && getCurruntActiveCalcQuantity() <= 15000) ? specialDiscountValueForArgentina : elem.getAttribute('data-value');
  const discount = (
    (countryCode === 'AR') &&
    loadSpecialDiscount &&
    isValidCurrencyForSpecialDiscount &&
    elemDataValue === '0' &&
    isQuantityEligibleForSpecialDiscount()
  ) ? specialDiscountValueForArgentina : elem.getAttribute('data-value');
	const disccountName = elem.getAttribute('data-name');
	const discountValue = ((valuePerTime * discount) / 100).toFixed(2);
	const disccountPerMonth = ((valuePerTime - discountValue) / parseInt(elem.getAttribute('data-time'))).toFixed(2);
	elem.parentElement.querySelectorAll('button').forEach(btn => { btn.classList.remove('btn-active') });
	elem.querySelector('button').classList.add('btn-active');

	if (discount > 0) {
		calcBox.querySelectorAll('.dp-price-old').forEach(item => { item.style.display = 'block' });
		if ((document.getElementById('range-plus-contactos').value > 4) && elemDataValue === '0') {
			calcBox.querySelectorAll('.dp-price-old').forEach(item => { item.style.display = 'none' });
		}
		calcBox.querySelectorAll('.dp-price-old .dp-price-old-money').forEach(item => { item.innerHTML = objCCurrency.symbol; });
		calcBox.querySelectorAll('.dp-price-old .dp-price-old-amount').forEach(item => { item.innerHTML = addCommas(initialValue); });
		calcBox.querySelectorAll('.dp-prices .amount').forEach(item => { item.innerHTML = addCommas(disccountPerMonth); });
		calcBox.querySelectorAll('.disccount-message .range-time').forEach(item => { item.innerHTML = disccountName; });
		calcBox.querySelectorAll('.disccount-message .disccount-value').forEach(item => { item.innerHTML = objCCurrency.symbol + ' ' + addCommas(((valuePerTime - discountValue).toFixed(2))); });
		calcBox.querySelectorAll('.disccount-message').forEach(item => { item.style.display = 'block' });
		if (calcBox.querySelector('.dp-price-old-money').innerHTML === "euro") {
			calcBox.querySelectorAll('.dp-price-old-money').forEach(item => { item.innerHTML = "€"; });
			calcBox.querySelectorAll('.disccount-message .disccount-value').forEach(item => { item.innerHTML = "€" + ' ' + addCommas(((valuePerTime - discountValue).toFixed(2))); });
		}
	} else {
		calcBox.querySelectorAll('.dp-price-old').forEach(item => { item.style.display = 'none'; });
		calcBox.querySelectorAll('.disccount-message').forEach(item => { item.style.display = 'none'; });
		calcBox.querySelectorAll('.dp-prices .amount').forEach(item => { item.innerHTML = addCommas(initialValue); });
	}

	const toggleDisccountMessageForArgentina = () => {
		if (countryCode === 'AR' && isValidCurrencyForSpecialDiscount && document.getElementById('range-plus-contactos').value <= 4 && specialDiscountValueForArgentina > 0) {
			// Mostrar mensaje de descuento ARG
			calcBox.querySelectorAll('.special-discount-old-price').forEach(item => { item.style.display = 'block' });
			calcBox.querySelectorAll('.special-discount-message').forEach(item => { item.style.display = 'block' });
			document.querySelector('.argetina-discount').classList.add('show');
			if (elemDataValue === '0') {
				calcBox.querySelectorAll('.disccount-message').forEach(item => { item.style.display = 'none' });
				calcBox.querySelectorAll('.dp-price-old').forEach(oldPrice => { oldPrice.classList.add('special-discount-old-price') })
			} else {
				calcBox.querySelectorAll('.disccount-message').forEach(item => { item.style.display = 'block' });
				calcBox.querySelectorAll('.special-discount-message').forEach(item => { item.style.display = 'none' });
				calcBox.querySelectorAll('.dp-price-old').forEach(oldPrice => { oldPrice.classList.remove('special-discount-old-price') })
			}

		} else {
			// Ocultar mensaje de descuento ARG
			calcBox.querySelectorAll('.dp-price-old').forEach(oldPrice => { oldPrice.classList.remove('special-discount-old-price') })
			calcBox.querySelectorAll('.special-discount-message').forEach(item => { item.style.display = 'none' });
			document.querySelector('.argetina-discount').classList.remove('show');
		}
	}
	toggleDisccountMessageForArgentina();
}


const currencySelectorChangePremium = (objectPricing) => {
	const changeListener = () => {
		const currencySelectorPlans = document.getElementById('curr-selector-plans');
		if (currencySelectorPlans) {
			let btnActive = document.querySelector('.dp-wrap-subscription li button.btn-active');
			let liBtn = btnActive.parentNode;

			setCookieWithSelector(currencySelector);

			loadRanges(objectPricing);

			loadDiscount(liBtn);
		}
	};
	currencySelector.addEventListener('change', changeListener);
}

const currencySelectorChange = () => {

	const handleCurrencyChange = () => {
		const selectedIndex = currencySelector.options.selectedIndex;
		const currencyName = currencySelector.value;
		const currencySymbol = currencySelector.options[selectedIndex].getAttribute("data-currency");
		const currencyRate = parseFloat(currencySelector.options[selectedIndex].getAttribute("data-rate"));

		setCookie('currencySelector', currencyName);

		const currentCurrency = {
			value: currencyName,
			symbol: currencySymbol,
			rate: currencyRate,
		};
		setCookie('currentCurrency', JSON.stringify(currentCurrency));

		updatePricesWithCurrency(currentCurrency);
	}

	const updatePricesWithCurrency = (currency) => {
		document.querySelectorAll('.dp-amount').forEach((item) => {
			const initialValue = parseFloat(item.querySelector('.dp-money-number').getAttribute('data-value'));
			const totalAmount = calculateTotalAmount(initialValue, currency.rate);
			const showDiscount = shouldShowDiscount(currency);
			updateAmountDisplay(item, totalAmount, currency.symbol);
			if (showDiscount) {
				applySpecialDiscount(item, initialValue, currency);
			} else {
				removeSpecialDiscount(item);
			}
		});
	}

	const calculateTotalAmount = (initialValue, rate) => {
		return addCommas((initialValue * rate).toFixed(2));
	}

	const updateAmountDisplay = (item, amount, symbol) => {
		item.querySelector('.dp-money-number').innerHTML = amount;
		item.querySelector('.dp-plan-currency').innerHTML = symbol;
	}

	const shouldShowDiscount = (currency) => {
		return (currency.value == 'ARS' || currency.value == 'USD') && countryCode === 'AR' && specialDiscountValueForArgentina > 0;
	}

	const applySpecialDiscount = (item, initialValue, currency) => {
    if (countryCode === 'AR'){
      if (!item.querySelector('.dp-price-old-amount')) return;
      const amount = initialValue * currency.rate;
      const amountWithDiscount = addCommas((amount - (amount * (specialDiscountValueForArgentina / 100))).toFixed(2));
      item.querySelector('.dp-money-number').innerHTML = amountWithDiscount;
      item.querySelector('.dp-price-old-amount').innerHTML = currency.symbol + addCommas(amount.toFixed(2));
      item.querySelector('.dp-price-old-amount').classList.add('show');
      document.getElementById('cardPremium').classList.add('special-discount--main');
    }
	}

	const removeSpecialDiscount = (item) => {
		if (item.querySelector('.dp-price-old-amount')) { item.querySelector('.dp-price-old-amount').classList.remove('show'); }
		document.getElementById('cardPremium').classList.remove('special-discount--main');
	}
	currencySelector.addEventListener('change', () => { handleCurrencyChange()
    document.querySelectorAll(".dp-plan-currency").forEach(elem => {
      elem.innerHTML = elem.innerHTML.replace("euro", "€");
    });
   });
}

const monthContactChange = () => {
	document.querySelectorAll('.dp-wrap-subscription li').forEach(elem => {
		// Esta función se llama en la sección por Contacto cuando se cambia la cantidad de meses en la subscription
		elem.addEventListener('click', () => {
			loadDiscount(elem);
		});
	});
}

const tabPlanChange = () => {
	document.querySelectorAll('.tab--item a').forEach(elem => {
		// Esta funcion escucha el cambio de tab en tipo de plan estas para guardarla y cargarla
		elem.addEventListener('click', (e) => {
			e.preventDefault();
			let dataTabItem = elem.parentElement.getAttribute('data-tab-item');
			document.querySelectorAll('.tab--item a, .tab--content').forEach(item => {
				item.classList.remove('active');
			});
			elem.closest('.tabs-nav').setAttribute('data-tab-active', dataTabItem);
			elem.classList.add('active');
			document.querySelector('.tab--content:nth-child(' + dataTabItem + ')').classList.add('active');
			if (history.pushState) {
				history.pushState(null, null, elem.parentElement.getAttribute('data-name'));
			} else {
				location.hash = elem.parentElement.getAttribute('data-name');
			}
			if (dataTabItem != 1) {
				document.querySelectorAll('.dp-price-old').forEach(item => {
					item.style.display = 'none'
				})
			} else {
				document.querySelectorAll('.dp-price-old').forEach(item => {
					item.style.display = 'block'
				})
			}
		})
	});
}

const detectHashUrlAndChange = () => {
	// Función para seleccionar una pestaña
	const selectedTab = (hashName) => {
		const tabsNav = document.querySelector('.tabs-nav');
		const tabItems = tabsNav.querySelectorAll('.tab--item');
		const tabContents = document.querySelectorAll('.tab--content');
		tabItems.forEach(item => {
			item.querySelector('.tab--link').classList.remove('active');
		});

		tabContents.forEach(content => {
			content.classList.remove('active');
		});

		const selectedItem = tabsNav.querySelector(`.tab--item[data-name="${hashName}"]`);
		const itemTab = selectedItem.getAttribute('data-tab-item');

		selectedItem.querySelector('.tab--link').classList.add('active');
		document.querySelector(`.tab--content:nth-child(${itemTab})`).classList.add('active');
	}
	// Obtener el hash de la URL
	const getHash = (urlHash) => {
		let hash = urlHash;
		if (hash.includes('?')) {
			hash = hash.split('?').find(content => content.includes('#'));
		}
		return hash;
	}

	const tabsNav = document.querySelector('.pricing-plans .tabs-nav');
	if (tabsNav) {
		const hash = document.location.hash;
		if (hash) {
			selectedTab(getHash(hash));
		}
	}

	// Agregar listeners de click para cambiar las pestañas
	document.querySelectorAll('.dp-calc-message .link-tab').forEach(item => {
		item.addEventListener('click', (e) => {
			e.preventDefault();
			const itemName = item.getAttribute('data-name');
			selectedTab(itemName);
			if (history.pushState) {
				history.pushState(null, null, itemName);
			} else {
				location.hash = itemName;
			}
		});
	});


}

const featuresListGroupListener = () => {

	const listItemGroup = document.querySelectorAll(".dp-list-item");
	const mediaQueryMatch = window.matchMedia("(min-width: 992px)")
	let open = false;

	listItemGroup.forEach(item => {
		item.addEventListener('click', e => {
			// item.childen[1] represents the dp-tooltip__container
			const dpTooltipContainer = item.children[1];
			const closeBtn = item.children[1].children[3];

			if (dpTooltipContainer != undefined) {
				if (e.target != closeBtn) {
					if (!mediaQueryMatch.matches && !open) {
						document.documentElement.style.overflow = 'hidden';
						document.body.scroll = "no";
						open = true;
					}
					listItemGroup.forEach(toolTipContainer => {
						if (toolTipContainer.children[1] != undefined) {
							toolTipContainer.children[1].classList.add("dp-none");
							toolTipContainer.children[1].classList.remove("dp-block")
							open = false;
						}
					});

					if (dpTooltipContainer.classList.contains("dp-none")) {
						dpTooltipContainer.classList.remove("dp-none")
						dpTooltipContainer.classList.add("dp-block")
					} else {
						dpTooltipContainer.classList.add("dp-none")
						dpTooltipContainer.classList.remove("dp-block")
					}
				}

				closeBtn.addEventListener('click', e => {
					dpTooltipContainer.classList.add("dp-none");
					dpTooltipContainer.classList.remove("dp-block");
					if (!mediaQueryMatch.matches) {
						document.documentElement.style.overflow = 'scroll';
						document.body.scroll = "yes";
					}
				});
			};
		});
	});
}

const activeListeners = (objectPricing) => {
	tabPricingListener();
	currencySelectorChangePremium(objectPricing);
	currencySelectorChange();
	monthContactChange();
	tabPlanChange(objectPricing);
	detectHashUrlAndChange();
	featuresListGroupListener();
}

const applyDiscountForArgentina = async () => {
	return countryCode === 'AR';
}

const replaceBasicDataValue = (objectPricing) => {
	const dataValueSpan = document.getElementById('basicDataValue');
	if (!dataValueSpan) return;
	const value = objectPricing[0].value;
	dataValueSpan.innerHTML = value;
	dataValueSpan.setAttribute('data-value', value);
}

const basicPricingLoad = async () => {
	showFixedNoticeForArgentina();
	const currencies = await getCurrenciesValues();
	loadSelectorOptions(currencies);
	const objectPricing = await getObjPricing();
	replaceBasicDataValue(objectPricing);
	loadRanges(objectPricing);
	activeListeners(objectPricing);
	setValueWithCookie();
	replaceEuroSymbol();
}

const loadPricingScript = async () => {
	const isPricingPage = document.querySelector('.pricing-plans');
	const isSmsPage = document.getElementById('pricingSms');
	const isSmsPricingPremium = document.getElementById('pagePricingMain');

	if (!isPricingPage) return;
	await basicPricingLoad();
	if (isSmsPage || isSmsPricingPremium) {
		loadSmsScript();
	}
}

let countryCode,
    loadSpecialDiscount,
    lang,
    currencySelector,
    specialDiscountValueForArgentina,
    time = 500;

(async () => {
  if (location.host === 'local-new.fromdoppler.com' || location.host === 'localhost') {
    time = 1500
  }
  countryCode = await getUserCountryCached();
  loadSpecialDiscount = applyDiscountForArgentina();
  lang = document.documentElement.lang;
  currencySelector = document.querySelector('.currency');
  specialDiscountValueForArgentina = getArgentinaDiscountValue();
  await loadPricingScript();
})();

